

// import React, { Suspense, useEffect, useState } from "react";
// import { extend } from "@react-three/fiber";
// import { Canvas } from "@react-three/fiber";

// import CanvasLoader from "../Loader";
// // import Computers from "./Computer";

// import { OrbitControls, Preload, useGLTF } from "@react-three/drei";
// extend ({OrbitControls, Preload, useGLTF})

// // import { Html} from "@react-three/drei";




// const Computers = () => {
//   const computer = useGLTF('./desktop_pc/scene.gltf')
//   return (
//     <mesh>
//       <hemisphereLight intensity={0.15} 
//       groundColor="black"/>
//       <pointLight intensity={1}/>

//       <primitive  
//       object={computer.scene}
//       scale={0.75}
//       position={[0,-3.25, -1.5]}
//       rotation={[-0.01, -0.2, -0.1]}
//       />
//     </mesh>
//   )
// }


// const ComputersCanvas = () => {
//   return (
    

//     <Canvas frameloop="demand" shadows
//     camera={{position: [20, 3, 5], fav: 25}}
//     gL={{preserveDrawingBuffer: true}}
//     >
//  <Suspense fallback={<CanvasLoader/>}>
//   <OrbitControls 
//   enableZoom={false}
//    maxPolarAngle={Math.PI / 2}
//    minPolarAngle = {Math.PI / 2}
//   />

//  <Computers/>

//  </Suspense>

//  <Preload all/>
//     </Canvas>
//   )
// }

// export default ComputersCanvas;

//3D COMPUTER MODEL 

import React, { Suspense, useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";

import CanvasLoader from '../Loader';

import { extend } from "@react-three/fiber";
import { OrbitControls, Preload, useGLTF } from "@react-three/drei";
// extend({OrbitControls , Preload, useGLTF})


// const Computers = () => {
//   const computer = useGLTF("./desktop_pc/scene.gltf");

//    return (
//       <>
    // <mesh>
    //  <hemisphereLight intensity={0.15} groundColor="black" />
    //  <pointLight intensity={1}/>
    //  <primitive
    //    object={computer.scene}
    //  />
    // </mesh>
//     </>
//   )
// }

const ComputersCanvas=( )=>{
  const [isMobile, setIsMobile] = useState(false);

  useEffect(()=> {
     // Add a listener for changes to the screen size
     const mediaQuery = window.matchMedia("(max-width: 500px)");


     //Set the initial value of the `isMobile` state variable
    setIsMobile(mediaQuery.matches);


    //Define a callback function to handle changes to the media query
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    }

    //Add the callback function as a listener for changes to the media query
    mediaQuery.addEventListener('change',
    handleMediaQueryChange
    );

    //Remove the listener when the component is unmounted()
    return () => {
      mediaQuery.removeEventListener('change',
      handleMediaQueryChange
      );
    }
  
  }, [])

   //THIS IS THE LINK OF THE COMPUTER
  const computer = useGLTF("./desktop_pc/scene.gltf");
  return (
    
    <Canvas
    
      frameloop='demand'
      shadows
      camera={{ position: [20, 3, 5], fov: 25 }}
      gl={{ preserveDrawingBuffer: true }}
    >
      <Suspense fallback={<CanvasLoader/>}>
        <OrbitControls
          enableZoom={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
       
        {/* <Computers  /> */}
        <mesh isMobile={isMobile}>
     <hemisphereLight intensity={0.15}
      groundColor="black" />
     <pointLight intensity={1}/>
     <spotLight 
     position={[-20, 50, 10]}
     angle={0.12}
     penumbra={1}
     intensity={1}
     castShadow
     shadow-mapSize={1024}
     />

     <primitive
       object={computer.scene}
       scale={ isMobile ? 0.6 : 0.70}
       position={isMobile ? [0, -4, -2.2] : [0, -3.25, -1.2]}
       rotation={[-0.01, -0.2, -0.1]}
     />
    </mesh>
      </Suspense>

      <Preload all />
    </Canvas>

);
};


export default ComputersCanvas;

